var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "9px",
    viewBox: "0 0 7 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Resync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations-2020",
    transform: "translate(-353.000000, -230.000000)",
    fill: "#5EC59A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "THUMBNAIL",
    transform: "translate(214.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(139.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Re-Sync",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78226544,0.0276328713 C6.91432859,0.0829058045 6.99998186,0.214435771 7,0.359936633 L7,3.20515112 C7,3.4034083 6.84208303,3.56480453 6.64709984,3.56480453 L3.85773528,3.56480453 C3.71505846,3.56480453 3.58644249,3.47713022 3.53159609,3.34241748 C3.47742099,3.20833389 3.50730257,3.05330321 3.60825042,2.9503812 L4.42744471,2.1155138 C3.55746806,1.60403099 2.42521571,1.72475433 1.68233102,2.48273555 L1.30914694,2.86335455 C1.1658714,3.00950307 0.978072847,3.08255882 0.789911436,3.08255882 C0.602385031,3.08255882 0.414259907,3.00948457 0.270984363,2.86335455 C-0.0156030097,2.57105751 -0.0156030097,2.09643566 0.270984363,1.80417563 L0.644132154,1.42357513 C1.96169746,0.079723031 4.02310904,-0.0467181986 5.48587306,1.03535078 L6.39788711,0.10514821 C6.49883496,0.00220769206 6.65049258,-0.0282877194 6.78226544,0.0276328713 Z M5.69083492,6.13683712 C5.977386,5.84455859 6.44242826,5.84455859 6.72932407,6.13683712 C7.01587516,6.42911565 7.01587516,6.90308985 6.72932407,7.19601604 L6.35650285,7.57596888 C5.64908779,8.2977553 4.7090246,8.69486181 3.70885354,8.69486181 C2.90831029,8.69486181 2.14829857,8.43626146 1.51318351,7.96547004 L0.602385031,8.8943773 C0.501455331,8.99729931 0.349471131,9.02844238 0.217716414,8.9725588 C0.0859616975,8.91663821 0,8.78571889 0,8.64025504 L0,5.79500354 C0,5.59615422 0.157916972,5.43536864 0.352900164,5.43536864 L3.14224657,5.43536864 C3.2849234,5.43536864 3.41355751,5.52302444 3.46838576,5.65712653 C3.52288744,5.79180227 3.49296957,5.94620379 3.39173144,6.04914431 L2.57222872,6.88528852 C2.9142612,7.08735763 3.30297572,7.19727434 3.70885354,7.19727434 C4.31657263,7.19727434 4.88842293,6.95580916 5.31797741,6.51741912 L5.69083492,6.13683712 Z",
    id: "Resync"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResyncIcon);
export default __webpack_public_path__ + "static/media/resync-icon.f63df683ea5201ec1092a9879df3b424.svg";
export { ForwardRef as ReactComponent };